import React from 'react';
import { DialogComponent } from '../DialogComponent/DialogComponent';
import { ButtonBase, DialogActions } from '@material-ui/core';

function PaymentPlanNotAvailableDialog({
  isOpen,
  t,
  translationPath,
  parentTranslationPath,
  onClose,
  onSave,
}) {
  function onSaveClicked() {
    onSave();
  }
  function onCloseClicked() {
    onClose();
  }

  return (
    <>
      <DialogComponent
        isOpen={isOpen}
        titleText={t('payment-plan-not-available')}
        saveText='save'
        maxWidth='sm'
        dialogContent={
          <>
            <>
              <div>{t('payment-plan-not-available-message')}</div>
              <DialogActions>
                <div className='d-flex-center fj-end py-0 pt-3'>
                  <ButtonBase
                    onClick={() => {
                      onCloseClicked();
                    }}
                    className='btns theme-propx outlined'
                  >
                    {t(`cancel`)}
                  </ButtonBase>

                  <ButtonBase
                    className='btns theme-propx solid mr-0'
                    onClick={() => {
                      onSaveClicked();
                    }}
                  >
                    {t(`proceed-anyways`)}
                  </ButtonBase>
                </div>
              </DialogActions>
            </>
          </>
        }
        onClose={() => {
          onCloseClicked();
        }}
        translationPath={translationPath}
        parentTranslationPath={parentTranslationPath}
      />
    </>
  );
}

export default PaymentPlanNotAvailableDialog;
